module.exports = __webpack_public_path__ + "static/media/img-3908208e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/sherwood-logo.png
// module id = 5301
// module chunks = 39